module.exports = __webpack_public_path__ + "img/pc_btn.3954054c.png";